import { RequestStatus, RequestType } from "../../firestore/Types/RequestSchema";
import { Badge } from "../Common/Badge";

export function Verification({ type, status, sendRequest }: { type: RequestType, status: RequestStatus, sendRequest?: () => Promise<void> }) {

    var description = "";
    var buttonText = "";
    switch (type) {
        case RequestType.WWCC:
            description = "WWCC Verifcation"
            break;
        case RequestType.Interview:
            description = "Book Interview"
            buttonText = "Book"
            break;
        default:
            description = "Some Certificate"
            break;
    }

    var statusText = "Required";
    var statusTagColor = "red";
    switch (status) {
        case RequestStatus.Approved:
            statusText = "Approved";
            statusTagColor = "green";
            break;
        case RequestStatus.Pending:
            statusText = "Pending";
            statusTagColor = "yellow";
            break;
        case RequestStatus.Rejected:
            statusText = "Rejected";
            statusTagColor = "red";
            break;
        default:
            statusText = "Required";
            statusTagColor = "red";
            break;
    }

    return (
        <div className="flex flex-row mb-2 ">
            <div className="flex flex-row max-w-[400px]">
                <div className="text-sm p-2 w-[200px]">{description}</div>
                    <div className="p-2">
                        <Badge label={statusText} color={statusTagColor}></Badge>
                    </div>
                </div>
            {sendRequest === undefined ? "" :
                <button className="primary-button ml-6" onClick={sendRequest}>{buttonText}</button>
            }
        </div>
    );
}